<template>
  <div class="colofon-social">
    <colofon-social-link
      href="http://app.nos.nl/op3/rdr2"
      @click.native="trackShareClick('copy')">
      <img
        class="social-img"
        src="../assets/img/icons/copy.svg">
    </colofon-social-link>
    <colofon-social-icon
      :target="true"
      href="https://www.facebook.com/share.php?u=http://app.nos.nl/op3/rdr2"
      @click.native="trackShareClick('facebook')">
      <img
        class="social-img"
        src="../assets/img/icons/facebook.svg">
    </colofon-social-icon>
    <colofon-social-icon
      :target="true"
      href="https://twitter.com/intent/tweet?text=Hoeveel mensen werkten aan de grootste game van dit moment? Bekijk de interactive van @NOSop3&url=http://app.nos.nl/op3/rdr2"
      @click.native="trackShareClick('twitter')">
      <img
        class="social-img"
        src="../assets/img/icons/twitter.svg">
    </colofon-social-icon>
    <colofon-social-icon
      href="mailto:?subject=Hoeveel mensen werkten aan de grootste game van dit moment? Bekijk de interactive van @NOSop3&body=http://app.nos.nl/op3/rdr2"
      @click.native="trackShareClick('mail')">
      <img
        class="social-img"
        src="../assets/img/icons/mail.svg">
    </colofon-social-icon>
  </div>
</template>
<script>
import ColofonSocialLink from './ColofonSocialLink';
import ColofonSocialIcon from './ColofonSocialIcon';
import { trackClick } from '../utils/track';

export default {
  components: {
    ColofonSocialLink,
    ColofonSocialIcon,
  },
  methods: {
    trackShareClick(target) {
      trackClick(`share-${target}`);
    },
  },
};
</script>
<style lang="scss" scoped>

  .colofon-social {
    display: flex;
    margin-left: -5px;
    justify-content: center;
    align-items: center;
  }

  .social-img {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/ColofonSocial.vue